module.exports = __webpack_public_path__ + "img/banner5.aeae44c7.png";